@for (category of categories; track category.Id) {
  <div>
    <a [routerLink]="category.routerLink" [queryParams]="{ 'category': category.Id}">{{category.Name}}</a>
  </div>
}
<div class="mb-3"></div>
